/**
 * Traveler roster API service — admin-managed add/remove and user search.
 */
import { AxiosResponse } from 'axios';
import { BaseApiService } from './baseApi';
import { TRIPS, TRAVELERS, USERS, SEARCH } from '../../constants';
import { UserSummary, TripMembership, AddTravelerRequest } from '../../types';
import { ServiceResult, ApiResponse } from '../../types/common/api.types';

export class TravelerApiService extends BaseApiService {
  async searchUsers(
    query: string,
    excludeTripId?: string
  ): Promise<ServiceResult<UserSummary[]>> {
    return this.withErrorHandling(async () => {
      const params = new URLSearchParams({
        username: query,
      });
      if (excludeTripId) {
        params.set('excludeTripId', excludeTripId);
      }
      const response: AxiosResponse<UserSummary[]> = await this.api.get(
        `${USERS}${SEARCH}?${params.toString()}`
      );
      return response.data;
    });
  }

  async addTraveler(
    tripId: string,
    body: AddTravelerRequest
  ): Promise<ServiceResult<TripMembership>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<TripMembership> = await this.api.post(
        `${TRIPS}/${tripId}${TRAVELERS}`,
        body
      );
      return response.data;
    });
  }

  async removeTraveler(
    tripId: string,
    userId: number
  ): Promise<ServiceResult<ApiResponse>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<ApiResponse> = await this.api.delete(
        `${TRIPS}/${tripId}${TRAVELERS}/${userId}`
      );
      return response.data;
    });
  }
}
